export default __webpack_public_path__ + "static/media/Traumatic Reflection.12139b1a.jpg";